module.exports = __webpack_public_path__ + "static/media/Recruitments_Welfare03.0760ca66.png";